import { BrowserRouter } from "react-router-dom";
import "./assets/css/_cssRest.scss";
import "./assets/css/_global.scss";
import "./assets/css/_mixin.scss";
import { TkMainLayout } from "./components/templates/TkMainLayout";
import TkRouters from "./routes/router";
import GlobalContextProvider from "./context/globalContext";
import { useEffect } from "react";
import BusinesContextProvider from "./context/businessContext";
import TkRouteContextProvider from "./context/tkRouteContext";
import { isMobileDevice } from "./utils/useTools";
import TkVersionChecker from "./components/atoms/TKVersionChecker";
import TkApiMask from "./components/atoms/TkApiMask";

function App() {
  useEffect(() => {
    console.log(
      "%c\n--------------------------------\n:  __        __  _    __  __   :\n:  \\ \\      / / / \\  |  \\/  |  :\n:   \\ \\ /\\ / / / _ \\ | |\\/| |  :\n:    \\ V  V / / ___ \\| |  | |  :\n:     \\_/\\_/ /_/   \\_\\_|  |_|  :\n--------------------------------",
      "color: purple; font-size: 20px; text-shadow: 2px 2px 2px gray; font-weight: bold;"
    );

    const isMobile = isMobileDevice();

    document.documentElement.style.setProperty(
      "--is-mobile",
      isMobile ? "true" : "false"
    );
  }, []);

  return (
    <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
      <GlobalContextProvider>
        <TkRouteContextProvider>
          <BusinesContextProvider>
            <TkMainLayout>
              <TkRouters />
            </TkMainLayout>
            <TkVersionChecker />
            <TkApiMask />
          </BusinesContextProvider>
        </TkRouteContextProvider>
      </GlobalContextProvider>
    </BrowserRouter>
  );
}

export default App;
